import {
  MdDashboard,
  MdStorage,
  MdSettings,
  MdPalette,
  MdSettingsInputComponent,
  MdFlashOn,
} from "react-icons/md";
import Modal from "./modal";
import { db, functions } from "./firebase";
import { useHistory, useParams } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import logo from "./Logo.png";
import { AppValue } from "./contexts/app";
import { MdLoop, MdError, MdCheckCircle } from "react-icons/md";
const deployApp = functions.httpsCallable("deployApp");

export default function NavBar() {
  const [active, setActive] = useState("canvas");
  const history = useHistory();
  const params = useParams();
  const { pages, plan } = useContext(AppValue);

  const handleHome = () => {
    history.push("/home");
  };

  const handleNav = (page) => {
    history.push(
      `/${params.appId}/${page.toLowerCase()}${
        params.pageId ? "/" + params.type + "/" + params.pageId : ""
      }`
    );
    setActive(page);
  };

  useEffect(() => {
    if (params.tab) {
      setActive(params.tab);
    }
  }, [params]);

  return (
    <div className="navbar">
      <div
        onClick={handleHome}
        style={{ marginLeft: 27, cursor: "pointer" }}
        className="navcontainer"
      >
        <img src={logo} alt="BREVITY LOGO" width={30} height={30} />
        <div className="logo-text">BREVITY</div>
      </div>
      <div
        style={{ flexGrow: 1, justifyContent: "center" }}
        className="navcontainer"
      >
        <NavBarItem
          setActive={handleNav}
          active={active}
          name="Canvas"
          Icon={MdDashboard}
        />
        <NavBarItem
          setActive={handleNav}
          active={active}
          name="Styles"
          Icon={MdPalette}
        />
        <NavBarItem
          setActive={handleNav}
          active={active}
          name="Database"
          Icon={MdStorage}
        />
        <NavBarItem
          setActive={handleNav}
          active={active}
          name="Connections"
          Icon={MdFlashOn}
        />
        <NavBarItem
          setActive={handleNav}
          active={active}
          name="Plugins"
          Icon={MdSettingsInputComponent}
        />
        <NavBarItem
          setActive={handleNav}
          active={active}
          name="Settings"
          Icon={MdSettings}
        />
      </div>

      <div className="navcontainer">
        <PreviewButton params={params} pages={pages} />
        <DeployButton plan={plan} appId={params.appId} />
      </div>
    </div>
  );
}

const NavBarItem = ({ active, Icon, name, setActive }) => {
  if (active !== name.toLowerCase()) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: 20,
          padding: "8px 16px 8px 16px",
          borderRadius: 3,
        }}
        onClick={() => setActive(name)}
      >
        <div
          style={{ marginLeft: 4, marginRight: 4, color: "#5D5F6D" }}
          className="nav-text"
        >
          {name}
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        marginLeft: 20,
        padding: "8px 16px 8px 16px",
        borderRadius: 8,
        boxShadow: "0px 6px 22px 4px rgba(48,51,84,.09)",
        fontFamily: "var(--font)",
      }}
    >
      <div
        style={{
          marginLeft: 4,
          marginRight: 4,
          fontWeight: 600,
          color: "#5D5F6D",
          fontSize: 14,
        }}
      >
        {name}
      </div>
    </div>
  );
};

const PreviewButton = ({ pages, params }) => {
  const handlePreview = () => {
    if (params.type !== "pages" || params.pageId === "index") {
      window.open(
        `https://app.brevitybuilder.com/preview/${params.appId}`,
        params.appId
      );
      return;
    }

    const currentPage = pages.find((x) => x.id === params.pageId);
    const parents = [];
    const findParent = (pageId) => {
      const parent = pages.find((x) => x.subpages.includes(pageId));
      if (parent) {
        parents.push(parent.name);
        findParent(parent.id);
      }
    };
    findParent(currentPage.id);
    const parentPath =
      parents.length > 0 ? parents.reverse().join("/") + "/" : "";
    window.open(
      `https://app.brevitybuilder.com/preview/${params.appId}/${parentPath}${currentPage.name}`,
      params.appId
    );
  };

  return (
    <button
      onClick={handlePreview}
      style={{
        border: "2px solid var(--main)",
        borderRadius: 8,
        padding: 6,
        width: 100,
        fontFamily: "var(--font)",
        cursor: "pointer",
        backgroundColor: "white",
        color: "var(--main)",
        fontWeight: 600,
        boxSizing: "border-box",
        marginRight: 8,
      }}
    >
      Preview
    </button>
  );
};

const DeployButton = ({ appId, plan }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [deployId, setDeployId] = useState("");
  const [status, setStatus] = useState(null);

  const handleDeploy = () => {
    setStatus({ fontend: "running", backend: "running" });
    deployApp({ appId, name, plan: "free" })
      .then(({ data }) => {
        console.log(data);
        setDeployId(data.deployId);
      })
      .catch(() => {
        console.log("IT Timed Out");
        setStatus({ fontend: "failed", backend: "failed" });
      });
  };

  useEffect(() => {
    let unsub;
    if (deployId) {
      unsub = db
        .collection("apps")
        .doc(appId)
        .collection("deploys")
        .doc(deployId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setStatus(doc.data());
          }
        });
    }
    return unsub;
  }, [deployId]);

  return (
    <>
      <button
        style={{
          border: "2px solid var(--main)",
          borderRadius: 8,
          padding: 6,
          width: 100,
          fontFamily: "var(--font)",
          cursor: "pointer",
          backgroundColor: "var(--main)",
          color: "#fff",
          fontWeight: 600,
        }}
        onClick={() => setOpen(true)}
      >
        Deploy
      </button>
      {plan === "free" && (
        <Modal open={open} onClose={() => setOpen(false)}>
          <div
            style={{
              width: 400,
              backgroundColor: "white",
              borderRadius: 8,
              padding: 15,
              fontFamily: "var(--font)",
              color: "#333",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className={"headerText"}>Upgrade your app to deploy</div>
            <div style={{ marginTop: 12 }}>
              Upgrading your app to a paid plan is required before you can
              deploy
            </div>
          </div>
        </Modal>
      )}
      {plan !== "free" && (
        <Modal open={open} onClose={() => {}}>
          {!status && (
            <div
              style={{
                width: 400,
                backgroundColor: "white",
                borderRadius: 8,
                padding: 15,
                fontFamily: "var(--font)",
                color: "#333",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className={"headerText"}>Ready to Deploy?</div>

              <div style={{ marginTop: 12 }}>
                This will deploy your app live to the intenet. Only do this once
                you are ready for people to see your work. It will take about 5
                minutes to complete
              </div>
              <div>
                <div
                  style={{ fontWeight: 600, marginTop: 20, marginBottom: 8 }}
                >
                  Deploy Name
                </div>
                <input
                  className="input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <button
                style={{
                  border: "2px solid var(--main)",
                  borderRadius: 8,
                  padding: 6,
                  fontFamily: "var(--font)",
                  cursor: "pointer",
                  backgroundColor: "var(--main)",
                  color: "#fff",
                  fontWeight: 600,
                  marginTop: 20,
                }}
                disabled={name.length === 0}
                onClick={handleDeploy}
              >
                DEPLOY
              </button>
              <button
                style={{
                  borderRadius: 8,
                  padding: 6,
                  fontFamily: "var(--font)",
                  cursor: "pointer",
                  border: 0,
                  color: "var(--main)",
                  fontWeight: 600,
                  marginTop: 20,
                }}
                onClick={() => setOpen(false)}
              >
                CANCEL
              </button>
            </div>
          )}
          {status && (
            <div
              style={{
                width: 400,
                backgroundColor: "white",
                borderRadius: 8,
                padding: 15,
                fontFamily: "var(--font)",
                color: "#333",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className={"headerText"}>Deploying your app</div>
              <div style={{ marginTop: 12 }}>Please leave this window open</div>
              <div
                style={{
                  display: "flex",
                  fontSize: 20,
                  padding: 8,
                  backgroundColor: "#f2f2f2",
                  fontWeight: 600,
                  borderRadius: 8,
                  marginTop: 12,
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>Frontend</div>
                <StatusIcon status={status.frontend} />
              </div>
              <div
                style={{
                  display: "flex",
                  fontSize: 20,
                  padding: 8,
                  backgroundColor: "#f2f2f2",
                  fontWeight: 600,
                  borderRadius: 8,
                  marginTop: 12,
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>Backend</div>
                <StatusIcon status={status.backend} />
              </div>
              {(status.frontend === "failed" ||
                status.backend === "failed") && (
                <div style={{ marginTop: 12 }}>
                  There was an error deploying your app. Please check there are
                  no issues in your editor. If this continues, please contact
                  support.
                </div>
              )}
              {status.frontend !== "running" && status.backend !== "running" && (
                <button
                  style={{
                    border: "2px solid var(--main)",
                    borderRadius: 8,
                    padding: 6,
                    fontFamily: "var(--font)",
                    cursor: "pointer",
                    backgroundColor: "var(--main)",
                    color: "#fff",
                    fontWeight: 600,
                    marginTop: 20,
                  }}
                  onClick={() => {
                    setStatus("");
                    setName("");
                    setOpen(false);
                  }}
                >
                  DONE
                </button>
              )}
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

const StatusIcon = ({ status }) => {
  console.log(status);
  if (status === "failed") {
    return <MdError style={{ fontSize: 32, color: "var(--danger)" }} />;
  }

  if (status === "complete") {
    return (
      <MdCheckCircle style={{ fontSize: 32, color: "var(--secondary)" }} />
    );
  }

  return (
    <MdLoop className="loop" style={{ fontSize: 32, color: "var(--main)" }} />
  );
};
